import { render, staticRenderFns } from "./suobi_chongzhi.vue?vue&type=template&id=ba30a1da&scoped=true"
import script from "./suobi_chongzhi.vue?vue&type=script&lang=js"
export * from "./suobi_chongzhi.vue?vue&type=script&lang=js"
import style0 from "./suobi_chongzhi.vue?vue&type=style&index=0&id=ba30a1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba30a1da",
  null
  
)

export default component.exports